// react
import React, { Component } from 'react';

// third-party
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from 'axios';
// import ReactPlayer from 'react-player/lazy'; // YouTube video di-comment sesuai instruksi user

// application
import languages from '../../i18n';
import StroykaSlick from '../shared/StroykaSlick';

const slickSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4500,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'cubic-bezier(0.16, 1, 0.3, 1)',
};

const DEFAULT_SLIDES = [
    {
        id: 1,
        url_web: 'https://i.imgur.com/5v1hpRc.png',
        url_mobile: 'https://i.imgur.com/zkrmVQj.png',
    },
    {
        id: 2,
        url_web: 'https://i.imgur.com/ft2Yjit.png',
        url_mobile: 'https://i.imgur.com/FLdD2IM.png',
    },
    {
        id: 3,
        url_web: 'https://i.imgur.com/PxqrAup.png',
        url_mobile: 'https://i.imgur.com/07QyKbv.png',
    },
    {
        id: 4,
        url_web: 'https://i.imgur.com/LjNytSA.png',
        url_mobile: 'https://i.imgur.com/Pt2deGB.png',
    },
];

class BlockSlideShowVideo extends Component {
    sliderRef = null;
    _isMounted = false;

    state = {
        slides: DEFAULT_SLIDES,
        videoweb: '',
        videomobile: '',
        loading: true,
    };

    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    fetchData = async () => {
        try {
            const [pageRes, carouselRes] = await Promise.allSettled([
                axios.post(`${process.env.REACT_APP_HOST_API}/iklan-ecommerce/page`, { page: 1, per_page: 10 }),
                axios.post(`${process.env.REACT_APP_HOST_API}/iklan-ecommerce/carousel1`, { page: 1, per_page: 10 }),
            ]);

            if (!this._isMounted) return;

            let videoweb = '';
            let videomobile = '';
            if (pageRes.status === 'fulfilled' && pageRes.value?.data?.response) {
                const p = pageRes.value.data.response;
                if (p.video_web) videoweb = p.video_web;
                if (p.video_mobile) videomobile = p.video_mobile;
            }

            let slides = DEFAULT_SLIDES;
            if (
                carouselRes.status === 'fulfilled' &&
                Array.isArray(carouselRes.value?.data?.response) &&
                carouselRes.value.data.response.length > 0
            ) {
                slides = carouselRes.value.data.response;
            }

            this.setState({
                videoweb,
                videomobile,
                slides,
                loading: false,
            });
        } catch (error) {
            console.error('Error loading banner resources:', error);
            if (this._isMounted) this.setState({ loading: false });
        }
    };

    render() {
        const { slides, videoweb } = this.state;
        const bannerList = slides && slides.length > 0 ? slides : DEFAULT_SLIDES;

        return (
            <div className="block block-tokopedia-banner">
                <div className="container">
                    <div className="tokopedia-banner__wrapper">
                        {/* Circular Previous Button */}
                        <button
                            type="button"
                            className="tokopedia-banner__arrow tokopedia-banner__arrow--prev"
                            onClick={() => this.sliderRef && this.sliderRef.slickPrev()}
                            aria-label="Slide Sebelumnya"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="15 18 9 12 15 6" />
                            </svg>
                        </button>

                        {/* Circular Next Button */}
                        <button
                            type="button"
                            className="tokopedia-banner__arrow tokopedia-banner__arrow--next"
                            onClick={() => this.sliderRef && this.sliderRef.slickNext()}
                            aria-label="Slide Selanjutnya"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </button>

                        {/* Main Full-width Banner Slider */}
                        <div className="tokopedia-banner__slider">
                            <StroykaSlick
                                forwardRef={(ref) => {
                                    this.sliderRef = ref;
                                }}
                                {...slickSettings}
                            >
                                {bannerList.map((slide, index) => (
                                    <div key={index} className="tokopedia-banner__slide">
                                        <Link to="/shop/category" className="tokopedia-banner__link">
                                            <picture>
                                                {slide.url_mobile && (
                                                    <source media="(max-width: 767px)" srcSet={slide.url_mobile} />
                                                )}
                                                <img
                                                    src={slide.url_web || slide.url_mobile}
                                                    alt="Promo Spesial Hokky Bangunan"
                                                    className="tokopedia-banner__img"
                                                    loading="lazy"
                                                />
                                            </picture>
                                        </Link>
                                    </div>
                                ))}
                            </StroykaSlick>
                        </div>

                        {/*
                            ========================================================================
                            NOTE: Video YouTube dinonaktifkan / di-comment dulu sesuai instruksi user
                            ========================================================================
                            <div className="tokopedia-banner__video d-none">
                                <ReactPlayer
                                    url={videoweb}
                                    pip={true}
                                    muted={true}
                                    loop={true}
                                    playing={true}
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                        */}
                    </div>
                </div>
            </div>
        );
    }
}

BlockSlideShowVideo.propTypes = {
    withDepartments: PropTypes.bool,
    locale: PropTypes.string,
};

BlockSlideShowVideo.defaultProps = {
    withDepartments: false,
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(BlockSlideShowVideo);
